/**
 * Utility functions
 * Утилиты для работы с классами CSS
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Объединяет классы Tailwind CSS
 * @param {...any} inputs - Классы для объединения
 * @returns {string} - Объединенные классы
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}



